import { ArrowRight, Sparkles } from 'lucide-react';

const REGISTER_URL = 'https://app.theonestack.com/research';

const pills = [
  '$5 starter credit',
  'No platform fee',
  'No subscription',
  'Web · Voice · Email',
  'CRM-ready leads',
];

export default function HeroSection() {
  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-ink-950 pt-24">
      <div className="pointer-events-none absolute inset-0 glow-pink" />
      <div className="pointer-events-none absolute inset-0 grid-pattern" />

      <div className="relative z-10 mx-auto max-w-5xl px-6 text-center">
        <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-rose-400/20 bg-rose-500/5 px-4 py-1.5">
          <span className="pulse-dot h-2 w-2 rounded-full bg-rose-400" />
          <Sparkles className="h-3.5 w-3.5 text-rose-300" />
          <span className="text-sm text-rose-200">Free to sign up · $5 in usage credit on us</span>
        </div>

        <h1 className="mb-6 text-4xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl md:text-6xl lg:text-7xl animate-fade-up">
          Research,{' '}
          <span className="bg-gradient-to-r from-rose-400 via-rose-500 to-violet-500 bg-clip-text text-transparent">
            automated.
          </span>
          <br />
          Every channel.
        </h1>

        <p className="mx-auto mb-10 max-w-2xl text-lg leading-relaxed text-slate-400 sm:text-xl animate-fade-up animate-delay-100">
          Tell THEO what you need to find. It searches the web, calls the agency,
          sends the email — and lands verified, cited, CRM-ready answers in
          minutes. Free to sign up with $5 in research credit on us. Pay only
          for what you actually run after that.
        </p>

        <div className="mb-12 flex flex-col items-center justify-center gap-4 sm:flex-row animate-fade-up animate-delay-200">
          <a
            href={REGISTER_URL}
            className="group flex items-center gap-2 rounded-xl bg-rose-500 px-8 py-4 text-base font-semibold text-white transition-all hover:bg-rose-400 hover:shadow-xl hover:shadow-rose-500/30"
          >
            Start free
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </a>
          <a
            href="#how"
            className="group flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-8 py-4 text-base font-semibold text-white transition-all hover:bg-white/10 hover:border-white/20"
          >
            See how it works
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 animate-fade-up animate-delay-300">
          {pills.map((pill) => (
            <span
              key={pill}
              className="rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-slate-300"
            >
              {pill}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
